import React from 'react';
import { MapPin, Phone, Instagram, Clock, Mail } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Olá! Estou no site e gostaria de tirar algumas dúvidas sobre o Centro de Lutas Jardim da Penha.");
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=${message}`, '_blank');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-border-medium pt-16 pb-8">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_jardim-lutas-premium/artifacts/ax3kmr9n_image.png" 
              alt="Centro de Lutas Jardim da Penha" 
              className="h-16 w-auto mb-4"
            />
            <p className="body-small text-gray-400 mb-4">
              Transformando vidas através das artes marciais desde 2009.
            </p>
            <div className="flex space-x-4">
              <a
                href={`https://instagram.com/${businessInfo.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-bg-card border border-border-medium rounded-full flex items-center justify-center hover:border-brand-primary hover:bg-brand-primary/10 transition-colors"
              >
                <Instagram className="w-5 h-5 text-brand-primary" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-6 text-brand-primary mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('modalidades')} className="body-small text-gray-400 hover:text-brand-primary transition-colors">
                  Modalidades
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('horarios')} className="body-small text-gray-400 hover:text-brand-primary transition-colors">
                  Horários
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('precos')} className="body-small text-gray-400 hover:text-brand-primary transition-colors">
                  Planos e Preços
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('depoimentos')} className="body-small text-gray-400 hover:text-brand-primary transition-colors">
                  Depoimentos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="body-small text-gray-400 hover:text-brand-primary transition-colors">
                  Perguntas Frequentes
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-6 text-brand-primary mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-brand-primary flex-shrink-0 mt-0.5" />
                <button
                  onClick={handleWhatsAppClick}
                  className="body-small text-gray-400 hover:text-brand-primary transition-colors text-left"
                >
                  {businessInfo.phone}
                </button>
              </li>
              <li className="flex items-start space-x-3">
                <Instagram className="w-5 h-5 text-brand-primary flex-shrink-0 mt-0.5" />
                <a
                  href={`https://instagram.com/${businessInfo.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="body-small text-gray-400 hover:text-brand-primary transition-colors"
                >
                  {businessInfo.instagram}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-brand-primary flex-shrink-0 mt-0.5" />
                <span className="body-small text-gray-400">
                  {businessInfo.fullAddress}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="heading-6 text-brand-primary mb-4">Horário de Funcionamento</h4>
            <div className="flex items-start space-x-3 mb-4">
              <Clock className="w-5 h-5 text-brand-primary flex-shrink-0 mt-0.5" />
              <div>
                <p className="body-small text-gray-400">Segunda a Sexta</p>
                <p className="body-small text-brand-primary font-semibold">6h às 22h</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Clock className="w-5 h-5 text-brand-primary flex-shrink-0 mt-0.5" />
              <div>
                <p className="body-small text-gray-400">Sábado</p>
                <p className="body-small text-brand-primary font-semibold">8h às 12h</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border-medium">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="caption text-gray-500">
              © {new Date().getFullYear()} Centro de Lutas Jardim da Penha. Todos os direitos reservados.
            </p>
            <p className="caption text-gray-500">
              Desenvolvido com 🥊 para transformar vidas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
